package music.jammers.client.shared.auth.data.repository

import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.contentType
import music.jammers.client.shared.auth.domain.repository.AuthRepository
import music.jammers.shared.auth.domain.model.Token

internal class AuthRepositoryImpl(
    private val client: HttpClient,
) : AuthRepository {

    override suspend fun login(token: Token): Token =
        client.post("auth/login") {
            setBody(token)
            contentType(ContentType.Application.Json)
        }.body<Token>()

    override suspend fun logout() {
        client.post("auth/logout").body<Unit>()
    }
}